// src/footer/FooterComponent.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './FooterComponent.css';

const FooterComponent = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <p>© Copyright {new Date().getFullYear()} - KissDateLove.com ❤️</p>
        </div>
        <div className="footer-right">
          <Link to="/help/general">General Help</Link>
          <Link to="/settings/privacy-policy">Privacy Policy</Link>
          <Link to="/settings/terms-of-use">Terms of Use</Link>
          <Link to="/forgotPassword">Forgot Account</Link>
          <Link to="/settings/contact-us">Contact Us</Link>
        </div>
      </div>
    </footer>
  );
};

export default FooterComponent;